// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3dXke","label":"CategoryService_label__1JDCu","location":"CategoryService_location__3zbif"};